let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("RU02s")).then(() => parcelRequire('9Pjdf'));